// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconChat = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M2.267 1.333c-.883 0-1.6.71-1.6 1.584v5.416c0 .874.717 1.584 1.6 1.584h.8v1.187c0 .151.085.287.22.354a.41.41 0 0 0 .42-.037l2.027-1.504H8.8c.883 0 1.6-.71 1.6-1.584V2.917c0-.874-.717-1.584-1.6-1.584zM8.8 10.708H6.4v.792c0 .873.718 1.583 1.6 1.583h2.933l1.36 1.505c.12.089.283.103.42.037a.39.39 0 0 0 .22-.354v-1.188h.8c.883 0 1.6-.71 1.6-1.583V6.75c0-.873-.717-1.583-1.6-1.583H11.2v3.166c0 1.312-1.075 2.375-2.4 2.375'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconChat)
const Memo = memo(ForwardRef)
export default Memo
